<div class="homeContainer">
  <section class="home">
    <h2 class="home--text">
      {{ 'landingTitle' | i18next
      }}{{ user ? (user.fullName | titlecase) : '-' }}
    </h2>
    <section class="vehicles">
      <div class="header">
        <h3 class="header--title">{{ 'vehicleStatus' | i18next }}</h3>
        <button
          mat-button
          class="header--btn"
          *ngIf="!vehiclesError"
          [routerLink]="['/list-requests']"
        >
          <div class="header--btn__container">
            <p class="header--btn__text">
              {{ 'landingGoTo' | i18next | uppercase }}
              {{ 'landingMyVehicles' | i18next | uppercase }}
            </p>
            <img
              src="../../../assets/icons/arrow_forward.svg"
              alt="Ir a mis vehículos"
            />
          </div>
        </button>
      </div>
      <div>
        <div class="text-center spinner-container" *ngIf="spinner">
          <div class="spinner-border spinner" role="status"></div>
        </div>
        <p class="text" *ngIf="vehiclesError">{{ vehiclesError }}</p>
        <app-card [data]="requestList" type="requestList"> </app-card>
      </div>
    </section>
    <section
      class="authorizations"
      *ngIf="
        user?.authorizer === 'CONTROLLER' ||
        user?.authorizer === 'DELEGATED_APPROVER' ||
        this.isPec
      "
    >
      <div class="header">
        <h3 class="header--title">{{ 'approveAuthorizations' | i18next }}</h3>
        <button
          mat-button
          class="header--btn nohover"
          *ngIf="!authorizationsError"
          [routerLink]="['/authorizations']"
        >
          <div class="header--btn__container">
            <p class="header--btn__text">
              {{ 'authTitle' | i18next | uppercase }}
            </p>
            <img
              src="../../../assets/icons/arrow_forward.svg"
              alt="{{ 'landingGoTo' | i18next }} {{
                'landingMyVehicles' | i18next
              }}"
            />
          </div>
        </button>
      </div>
      <div>
        <p class="text" *ngIf="authorizationsError">
          {{ authorizationsError }}
        </p>
        <app-card [data]="authorizations" type="authorizations"> </app-card>
      </div>
    </section>
    <button class="home--scrollDown" (click)="scrollDown('requestsList')">
      <img
        class="home--scrollDown__icon"
        src="../../../assets/icons/scroll-down.svg"
        alt="Ir abajo"
      />
    </button>
  </section>
</div>
<section class="newRequest">
  <div id="requestsList" class="newRequest--main">
    <div class="newRequest--container">
      <h1 class="newRequest--container__title">
        {{ 'menuTitle' | i18next }}
      </h1>
      <p class="newRequest--container__subtitle">
        {{ 'landingRequestSubtitle' | i18next }}
      </p>
      <button
        id="documentation"
        class="newRequest--container__btn"
        routerLink="/menu"
        mat-button
      >
        {{ 'requestBtn' | i18next | uppercase }}
      </button>
    </div>
    <button
      *ngIf="campaignsList?.length > 0 && enableCampaigns"
      class="newRequest--scrollDown"
      (click)="scrollDown('campaigns')"
    >
      <img
        class="newRequest--scrollDown__icon"
        src="../../../assets/icons/scroll-down.svg"
        alt="Ir abajo"
      />
    </button>
  </div>
</section>
